import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const options = { role: ROLE.BUSINESS };
const path = "business/users";

export const List = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};

export const Details = async (id) => {
  return await axiosInstance(options).get(`${path}/details?o_id=${id}`);
};

export const BlockUnblockUser = async (values) => {
  return await axiosInstance(options).post(`${path}/block-unblock-user`, values);
};

export const CustomerList = async (search = "") => {
  return await axiosInstance(options).get(`${path}/customer-list?search=${encodeURIComponent(search)}`);
};